import './tablero.scss';
import template from './tablero.html';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import { fullscreen } from 'core/util';

// MODULE EXPORTS
export let TableroEspecialistasComponent = {
  templateUrl: template,
  selector: 'tableroEspecialistas',
  bindings: {
    translations: '='
  },
  controller: TableroCtrl,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(commonI18N);

TableroCtrl.$inject = ['$ngRedux', '$state', 'Filter', '$timeout'];


function TableroCtrl($ngRedux, $state, Filter, $timeout) {
  Object.assign(this, { $ngRedux, $state });
  this.mapStateToThis = mapStateToThis.bind(this);
  this.renderCliente = renderCliente.bind(this);
  this.renderEspecialista = renderEspecialista.bind(this);
  this.renderServicio = renderServicio.bind(this);
  this.fullscreen = () => { $timeout(() => fullscreen()); };

  this.localModel = {
    empleados: {}
  };

  let unsubscribe;
  this.$onDestroy = () => {
    $ngRedux.dispatch(rest.actions.ordenesDetallePendientes.reset());
    unsubscribe();
    this.loading = false;
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, {})(this);
    $ngRedux.dispatch(rest.actions.ordenesDetallePendientes());
    this.loading = this.loading === undefined ? true : false;
  };

  function mapStateToThis(state) {
    let self = this;
    if (state.ordenesDetallePendientes.data && state.ordenesDetallePendientes.data.length > 0 && !Object.keys(this.localModel.empleados).length) {
      state.ordenesDetallePendientes.data.forEach(function(ordenDetalle) {
        let empleado = self.localModel.empleados[ordenDetalle.especialista.id] || { empleado: ordenDetalle.especialista, ordenes: [], servicios: {} };
        empleado.ordenes.push({ ordenDetalle, cliente: ordenDetalle.cliente });
        empleado.servicios[ordenDetalle.servicioTransient.id] = ordenDetalle.servicioTransient;
        self.localModel.empleados[ordenDetalle.especialista.id] = empleado;
      });
      self.loading = false;
      self.sinResultados = false;
    }

    if (state.ordenesDetallePendientes.data && state.ordenesDetallePendientes.data.length === 0) {
      self.loading = false;
      self.sinResultados = true;
    }

    return {};
  }

  function renderCliente(cliente) {
    return `${cliente.razonSocial}`;
  }

  function renderEspecialista(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  function renderServicio(empleado) {
    let servicios = [];
    for (var id in empleado.servicios) {
      servicios.push(`${empleado.servicios[id].nombre}`);
    }
    return servicios.join(' - ');
  }

}


// WEBPACK FOOTER //
// ./src/components/tablero-especialistas/tablero.component.js